import {ServiceModel} from '../../model'
import {aditionalValues} from '../../../../util/utilitario'
export const initValues: ServiceModel = {
  id: '',
  nombre: '',
  descripcion: '',
  codigo: '',
  tipoRopaId: '',
  estado: '',
  estadoServicio: '',
  tipoAdministracion: '',
  tipoOrdenLavadoId: '',
  tipoOrdenLavadoNombre: '',
  ...aditionalValues,
}
